
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/overview",
      function () {
        return require("private-next-pages/syncs/overview.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/overview"])
      });
    }
  